import React from 'react';

export const spotifyIcon = ({ ariaLabel = 'Spotify' }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="19"
      height="19"
      role="img"
      aria-label={ariaLabel}
    >
      <path d="M9.5 0C4.253 0 0 4.253 0 9.5S4.253 19 9.5 19 19 14.747 19 9.5 14.747 0 9.5 0zm4.368 13.703c-.19.284-.522.38-.808.19-2.232-1.378-5.035-1.663-8.34-.91-.331.096-.617-.142-.712-.426-.095-.333.142-.617.427-.712 3.61-.807 6.745-.475 9.217 1.045.332.142.379.522.238.808zm1.14-2.613c-.238.332-.665.475-1 .237-2.565-1.567-6.463-2.043-9.456-1.093-.38.095-.807-.095-.902-.475-.095-.38.095-.807.475-.902 3.42-.997 7.79-.474 10.736 1.235.285.143.427.617.19.95zm.095-2.66c-3.088-1.805-8.17-1.995-11.114-1.093-.475.142-.95-.143-1.092-.57-.142-.475.142-.95.57-1.092 3.373-1 8.978-.807 12.54 1.283.427.237.57.807.332 1.234-.237.332-.807.475-1.234.332z" />
    </svg>
  );
};

